import axios from 'axios';
import { Tree } from 'antd';
import { flattenDeep } from 'lodash';
import { connect } from 'react-redux';
import SinglePlot from '../SinglePlot';
import React, { Fragment, useState, useEffect } from 'react';
import { DownOutlined } from '@ant-design/icons';
import localStorage from '../../../utils/localStorage';
import { API_HIERARCHYMODULE } from '../../../commons/api';
import { GetDefaultHierarchy } from '../../CustomerAssetDeviceConfiguration/APICalls';

const ModuleWiseDashboard = (props) => {
  const [treeData, setTreeData] = useState([]);
  const [dynamicName, setDynamicName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [Module, setModule] = useState('');

  useEffect(() => {
    const pathSnippets = props.location.pathname.split('/rubus/ModuleWiseHMI/').filter((i) => i);
    const path = pathSnippets[0].split('/').filter((i) => i);
    const initialModule = path[path.length - 1];
    getHierarchyLevels(initialModule);
  }, [props.location.pathname]);

  const getHierarchyLevels = async (Module) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const defaultHierarchyCodeResponse = await GetDefaultHierarchy();
    const HierarchyCode =
      defaultHierarchyCodeResponse?.[0]?.HierarchyCode || '';

    const headers = {
      method: 'GET',
      url: `${API_HIERARCHYMODULE.GetHierarchyByLevels}?SiteId=${siteId}&HierarchyCode=${HierarchyCode}&Module=${Module}&Level=1`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    axios(headers)
      .then(({ data }) => {
        if (Array.isArray(data)) {
          let initialDynamicName = '';
          let initialDisplayName = '';

          if (data[0]?.children?.[0]?.Code) {
            initialDynamicName = data[0].children[0].Code;
            initialDisplayName = data[0].children[0].Name;
          }
          expandAll(data);
          setTreeData(data);
          setModule(Module);
          setDynamicName(initialDynamicName);
          setDisplayName(initialDisplayName);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const expandAll = (treeData) => {
    getAllKeys(treeData).then(keys => {
      setExpandedKeys(keys);
    });
  };

  const getAllKeys = async (data) => {
    const nestedKeys = data.map((node) => {
      let childKeys = [];
      // if (node.children) {
      //   childKeys = getAllKeys(node.children);
      // }
      return [childKeys, node.Id];
    });
    return flattenDeep(nestedKeys);
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <Tree.TreeNode title={<>{item.Name}</>} key={item.Id} dataRef={item}>
              {renderTreeNodes(item.children, item)}
            </Tree.TreeNode>
          );
        }
        return (
          <Tree.TreeNode
            key={item.key}
            title={
              <div
                onClick={() => {
                  setDynamicName(item.Code);
                  setDisplayName(item.Name);
                }}
              >
                <>{item.Name}</>
              </div>
            }
            dataRef={item}
          />
        );
      })
    );
  };
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          minHeight: window.innerHeight - 67,
          padding: '20px',
        }}
      >
        <div
          style={{
            width: '100%',
            flex: '25%',
            overflowY: 'auto',
            height: window.innerHeight - 140,
          }}
        >
          <Tree
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            showLine
            defaultExpandAll={false}
            switcherIcon={<DownOutlined />}
          >
            {renderTreeNodes(treeData)}
          </Tree>
        </div>

        <div
          style={{
            flex: '75%',
            paddingLeft: '17px',
            borderLeft: '1px dashed white',
          }}
        >
          {displayName && (
            <div
              style={{
                
                fontWeight: 'bold',
                display: 'flex',
                justifyContent: 'center',
                padding: '10px 0px',
              }}
            >
              {displayName}
            </div>
          )}
          <SinglePlot
            triggerPoint="dashboard"
            match={{
              params: {
                hmiName: Module,
                type: 'distinctByParent',
                dynamicName,
              },
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(ModuleWiseDashboard);
